import topAdv from './top-adv.vue'

export default topAdv